import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { DataService } from "../../../@core/services/data.service";
import { InstagramService } from "../../../@core/services/instagram.service";
import { UserService } from "../../../@core/services/user.service";
import { MatDialog } from "@angular/material/dialog";
import * as Sentry from "@sentry/browser";
import { MaterialDisplayImageInstagramComponent } from "./display-image-instagram/display-image-instagram.component";
import { InstagramInterface } from "../../../@core/models/site-data.model";
import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-instagram",
  templateUrl: "./instagram.component.html",
  styleUrls: ["./instagram.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MaterialInstagramComponent implements OnInit, OnDestroy {
  userInstagramData: any;
  active: boolean = false;
  instagramEnabled: boolean = false;
  loading: boolean = true;
  position: number = 0;
  displayLimit: number = 6;
  moduleInfo: string;
  isStock: string = "";
  activatePadding: boolean = false;
  siteId: string = "";
  title: string = "";
  backgroundColor: string = "";
  textColor: string = "";
  titleSize: string = "";
  data: InstagramInterface;
  subscription: Subscription;

  constructor(
    private dialog: MatDialog,
    private dataService: DataService,
    private userService: UserService,
    private instagramService: InstagramService
  ) {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "InstagramComponent");
    });
    this.subscription = this.dataService.getSiteId().subscribe((siteId) => {
      this.siteId = siteId;
    });
    const instagram = this.dataService.instagram$.getValue();
    if (instagram && Object.keys(instagram).length) {
      if (this.checkTokenExpiration(instagram["createdAt"]) >= 50) {
        this.subscription = this.instagramService
          .refreshInstagramToken(instagram["access_token"])
          .subscribe((longAccess) => {
            const instagramToken = {
              ...longAccess,
              user_id: instagram["user_id"],
              createdAt: new Date().getTime(),
            };
            this.dataService
              .updateSite({
                email: this.userService.getUserData().email,
                siteId: this.siteId,
                instagramToken: instagramToken,
              })
              .subscribe((res) => {});
          });
      }
      try {
        this.subscription = this.instagramService
          .getDataFromInstagram(instagram)
          .subscribe((userInstaData) => {
            this.userInstagramData = userInstaData;
            this.instagramEnabled = true;
            this.loading = false;
          });
      } catch (error) {
        if (!environment.production) {
          console.log(error);
        }
      }
    }
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
  }
  loadMore() {
    this.displayLimit = this.displayLimit + 6;
  }

  openImage(image: object) {
    let data = { selectedImage: image, images: this.userInstagramData };
    const dialogRef = this.dialog.open(MaterialDisplayImageInstagramComponent, {
      data,
      panelClass: "p-dialog",
    });
    this.subscription = dialogRef
      .afterClosed()
      .subscribe((res: { code: string; active: string }) => {
        if (res.active) {
          // TODO: save code plugin
        }
      });
  }

  ngOnInit() {
    this.title = this.data ? this.data.title : "";
    this.titleSize = this.data ? this.data.titleSize : "";
    this.textColor = this.data ? this.data.textColor : "";
    this.backgroundColor = this.data ? this.data.backgroundColor : "";
  }

  checkTokenExpiration(createdAt: number) {
    const current = new Date();
    const msPerDay = 60 * 1000 * 60 * 24;
    const dateCreatedAt = new Date(createdAt);
    const elapsed = current.getTime() - dateCreatedAt.getTime();
    const timeAgo = Math.round(elapsed / msPerDay);
    return timeAgo;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
